



































import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import { BrandConfigKeys } from "@/data/constants";

@Component
export default class CProdAssistanceComponent extends Mixins(
  CProdInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !(
      this.$store.getters["brand/config"][
        BrandConfigKeys.UI_CLIENT_APP_DISABLE_SUPPORT_SYSTEM
      ] ?? false
    );
  }
}
